import React from "react";

const Search = ({
  handleRatedRes,
  searchText,
  setSearchText,
  handleSearchBox,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-center px-4 py-4 bg-white border-b border-gray-300">
      <input
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search"
        className="border-2 text-decor h-9 border-slate-950 my-4 rounded-l-full px-2 py-1 sm:w-96 mt-24"
      />
      <button
        className="bg-slate-950 h-9 text-decor mt-24 text-white my-4 px-2 py-1 rounded-r-lg -ml-1 hover:bg-slate-700"
        onClick={handleSearchBox}
      >
        Search
      </button>
      <div className="hidden md:block">
        <button
          className="bg-slate-950 text-decor mt-24 ml-11 text-white my-4 px-2 py-1 rounded-lg hover:bg-slate-700"
          onClick={handleRatedRes}
        >
          Top Rated Restaurent
        </button>
      </div>
    </div>
  );
};

export default Search;
